import { Reducer } from "../../lib/redux";
import GroupLinkedDevice from "../../model/GroupLinkedDevice";
import { GroupLinkedDeviceActions } from "./actions";
import { GroupLinkedDeviceActionTypes } from "./types";
import { extend } from "../../utils/vanilla";

export let defaultGroupLinkedDevices: IIdDictionary<IIdDictionary<GroupLinkedDevice>> = {};

export let groupLinkedDevices: Reducer<IIdDictionary<IIdDictionary<GroupLinkedDevice>>, GroupLinkedDeviceActions> = (state = defaultGroupLinkedDevices, action) => {
        switch (action.type) {
            case GroupLinkedDeviceActionTypes.SET_GROUPLINKEDDEVICES: {
                let deviceId = action.payload.deviceId;
                if (deviceId) {
                    return {
                        ...state,
                        [deviceId]: extend(true, {}, action.payload.groupLinkedDevices)
                    };
                }
                return state;
            }
            case GroupLinkedDeviceActionTypes.CLEAR_GROUPLINKEDDEVICES:
                return {};
            default:
                return state;
        }
};